<template>
  <HomeContainer title="İletişim">
    <div class="columns">
      <div class="column is-5">
        <div class="content" style="padding-top:20px; padding-left:20px;">
          <b>Neta Denetim</b>
          <p>
            <br />Ağaoğlu My Office <br />Barbaros Mah. Çiğdem Sok. No: 18 <br />34746 Ataşehir /
            İstanbul
          </p>
          <p>
            <b>Email:</b>
            <a href="mailto:info@netadenetim.com" style="padding-left:10px;"
              >info@netadenetim.com</a
            >
          </p>
          <p>
            <b>Tel:</b>
            <a href="tel:+902162505576" style="padding-left:10px;">+90 (216) 250 5576</a>
          </p>
        </div>

        <div class="b-portlet">
          <form v-on:submit.prevent="onSend()">
            <div class="b-portlet-header header has-text-centered">
              <h1 class="is-size-5 has-text-weight-bold">{{ $t('title.contactForm') }}</h1>
            </div>
            <div class="b-portlet-body">
              <b-field
                :type="{ 'is-danger': errors.has('fullname') }"
                :message="errors.first('fullname')"
              >
                <b-input
                  icon-pack="fas"
                  icon="user"
                  :placeholder="$t('validation.attributes.fullname')"
                  v-model="fullname"
                  name="fullname"
                  v-validate="'required'"
                />
              </b-field>
              <b-field
                class="field"
                :type="{ 'is-danger': errors.has('email') }"
                :message="errors.first('email')"
              >
                <b-input
                  icon-pack="fas"
                  icon="envelope"
                  :placeholder="$t('validation.attributes.email')"
                  v-model="email"
                  name="email"
                  v-validate="'required|email'"
                />
              </b-field>
              <b-field
                class="field"
              >
                <b-input
                  icon-pack="fas"
                  icon="phone"
                  placeholder="Telefon"
                  v-model="phone"
                  name="phone"
                />
              </b-field>
              <b-field
                :type="{ 'is-danger': errors.has('message') }"
                :message="errors.first('message')"
              >
                <b-input
                  type="textarea"
                  :placeholder="$t('validation.attributes.message')"
                  v-model="message"
                  name="message"
                  v-validate="'required'"
                />
              </b-field>
            </div>
            <div class="b-portlet-footer">
              <div class="field is-grouped">
                <div class="control">
                  <button class="button is-primary">{{ $t('button.send') }}</button>
                  <span class="has-text-success" v-if="isSentSuccess" style="padding-left: 20px;">{{
                    $t('description.contactFormSuccessMessage')
                  }}</span>
                  <span
                    class="has-text-danger"
                    v-else-if="isSentError"
                    style="padding-left: 20px;"
                    >{{ $t('description.contactFormErrorMessage') }}</span
                  >
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="column is-7">
        <div class="section is-centered">
          <div style="width: 100%;">
            <iframe
              style="height:570px;"
              width="100%"
              src="https://maps.google.com/maps?width=100%&amp;height=600&amp;hl=en&amp;q=Neta%20Denetim+(Neta%20Denetim)&amp;ie=UTF8&amp;t=&amp;z=14&amp;iwloc=B&amp;output=embed"
              frameborder="0"
              scrolling="no"
              marginheight="0"
              marginwidth="0"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </HomeContainer>
</template>
<script>
import { mapGetters } from 'vuex'
import ApiService from '../../_api/api.service'
import { APP_ID } from '../../_helpers/config'

export default {
  data() {
    return {
      fullname: null,
      email: null,
      message: null,
      isSentSuccess: false,
      isSentError: false
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'isAuthenticated'])
  },
  methods: {
    onSend() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$recaptcha('contact').then(token => {
            this.sendContactForm(token)
          })
        }
      })
    },
    sendContactForm(recaptchaToken) {
      this.isSentSuccess = false
      ApiService.post('/user/sendmessage', {
        registeredEmail: this.isAuthenticated ? this.currentUser.email : null,
        recaptchaToken,
        fullname: this.fullname,
        email: this.email,
        phone: this.phone,
        message: this.message,
        appId: APP_ID
      }).then(data => {
        if (data && data.isSent === true) {
          this.isSentSuccess = true
          this.fullname = null
          this.email = null
          this.phone = null
          this.message = null
        } else {
          this.isSentError = true
        }
      })
    }
  }
}
</script>
